import React from 'react'

const CloseIcon = ({ width, height, fill }) => (
    <svg 
        height={height}
        width={width}
        fill={fill} 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <path 
                d="M12,23A11,11,0,1,0,1,12,11.013,11.013,0,0,0,12,23ZM12,
                3a9,9,0,1,1-9,9A9.01,9.01,0,0,1,12,3ZM8.293,14.293,10.586,
                12,8.293,9.707A1,1,0,0,1,9.707,8.293L12,10.586l2.293-2.293a1,
                1,0,0,1,1.414,1.414L13.414,12l2.293,2.293a1,1,0,1,1-1.414,
                1.414L12,13.414,9.707,15.707a1,1,0,0,1-1.414-1.414Z"
            >
            </path>
        </g>
    </svg>
)
export default CloseIcon
